import * as types from './type';

import { PropertyType }  from  '../../services/propertyType';

export function getPropertyTypes() {
    return {
      type: types.GET_PROPERTY_TYPES,
      payload: PropertyType.getPropertyTypes(),
    };
};

